module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs":"react","commonjs2":"react","amd":"react"}
// module id = 5
// module chunks = 0